import { motion, useReducedMotion } from "framer-motion";

/**
 * MaskedReveal — line-by-line masked-clip reveal for headings.
 * Each element of `lines` becomes its own mask row.
 * Guaranteed visible-on-load: initial y is small; if animation blocked we still show content.
 */
export function MaskedReveal({
  lines = [],
  as = "h1",
  className = "",
  delay = 0,
  stagger = 0.15,
  duration = 1.05,
  testId,
}) {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.h1;
  return (
    <Tag data-testid={testId} className={className}>
      {lines.map((line, i) => (
        <span className="mask-line" key={i} aria-hidden={false}>
          <motion.span
            initial={reduce ? { y: 0 } : { y: "110%" }}
            animate={{ y: 0 }}
            transition={{
              duration,
              delay: delay + i * stagger,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

/**
 * Rise — simple fade + translate on scroll into view.
 */
export function Rise({
  children,
  className = "",
  delay = 0,
  y = 28,
  once = true,
  amount = 0.25,
}) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
